export default {
  name: 'en',
  form: {
    search: 'search',
    reset: 'reset',
    inputPlaceholder: 'please enter',
    selectPlaceholder: 'please select',
    add: 'add',
    previousStep: 'previous step',
    nextStep: 'next step',
    minNum: 'at least keep',
    minNumUnit: 'items',
  },
  tagSelect: {
    all: 'all',
    expand: 'expand',
    retract: 'retract',
  },
  select: {
    all: 'all',
  },
  table: {
    action: 'action',
    more: 'more',
    addData: 'add data',
    compact: 'compact',
    loose: 'loose',
    leftFixed: 'left fixed',
    unpin: 'unpin',
    rightFixed: 'right fiexed',
    unfixed: 'unfixed',
    density: 'density',
    columnSetting: 'column setting',
    columnDisplay: 'column display',
    deleteTip: 'Are you sure you want to delete this data?',
  },
  dialog: {
    got: 'got it',
    tip: 'tip',
  },
  crud: {
    add: 'add',
    export: 'export',
    unselect: 'unselect',
    selected: 'selected',
    term: 'term',
    multipleDelete: 'multiple delete',
    deleteTip: 'Are you sure you want to delete this data?',
    multipleDeleteTip: 'Are you sure you want to delete these selected data?',
  },
  watermark: {
    tip: 'The current environment does not support Canvas',
  },
  common: {
    save: 'save',
    cancel: 'cancel',
    edit: 'edit',
    delete: 'delete',
    confirm: 'confirm',
    view: 'view',
    success: 'success',
    operationSuccess: 'operation success',
    default: 'default',
    refresh: 'refresh',
    fullScreen: 'full screen',
    cancelFullScreen: 'cancel full screen',
    reset: 'reset',
    search: 'search',
    submit: 'submit',
  },
}
